<div class="relative w-full h-full flex flex-col pt-18">
    <div class="flex flex-col p-2 pt-0 w-full h-full gap-2">
        <p-card>
            <div class="flex w-full justify-end">
                <p-button (click)="openAddEditViewDialog('add')"
                    (keydown.enter)="$event.preventDefault(); openAddEditViewDialog('add')"
                    (keydown.space)="$event.preventDefault(); openAddEditViewDialog('add')" styleClass="btn-primary">
                    <app-icon-bold-add-square/>
                    Adicionar
                </p-button>
            </div>
        </p-card>
        <p-card>
            <p-table #dt
                     (onLazyLoad)="onLazyLoad($event)"
                     [filterDelay]="0"
                     [lazy]="true"
                     [loading]="loading" [paginator]="true" [rowHover]="true"
                     [rowsPerPageOptions]="[10, 25, 50]"
                     [rows]="currentSize"
                     [showCurrentPageReport]="true" [showLoader]="false"
                     [totalRecords]="totalRecords" [value]="customers"
                     currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} entradas">
                <ng-template pTemplate="header">
                    <tr>
                        <th scope="col" pSortableColumn="nome">
                            <div class="flex justify-between items-center">
                                Nome
                                <p-sortIcon field="nome"/>
                            </div>
                        </th>
                        <th scope="col" pSortableColumn="area">
                            <div class="flex justify-between items-center">
                                Área
                                <p-sortIcon field="area"/>
                            </div>
                        </th>
                        <th scope="col" pSortableColumn="cargo">
                            <div class="flex justify-between items-center">
                                Cargo
                                <p-sortIcon field="cargo"/>
                            </div>
                        </th>
                        <th scope="col" pSortableColumn="administrador">
                            <div class="flex justify-between items-center">
                                Perfil
                                <p-sortIcon field="administrador"/>
                            </div>
                        </th>
                        <th scope="col" alignFrozen="right" pFrozenColumn style="width: 5rem">
                            <div class="flex justify-between items-center">Ações</div>
                        </th>
                    </tr>

                    <tr>

                        <th scope="col">
                            <p-iconfield size="small">
                                <p-inputicon><i class="pi pi-search"></i></p-inputicon>
                                <input (input)="onFilterInput($event, 'nome')"
                                       [ngModel]="currentFilters['nome']"
                                       fluid
                                       maxlength="255" pInputText placeholder="Pesquise" size="small" type="text"/>
                                @if (currentFilters['nome']) {
                                    <p-inputicon
                                            (click)="clearFilter('nome')"
                                            (keydown.enter)="$event.preventDefault(); clearFilter('nome')"
                                            (keydown.space)="$event.preventDefault(); clearFilter('nome')"
                                            tabindex="0"
                                            class="pi pi-times cursor-pointer"
                                    />
                                }
                            </p-iconfield>
                        </th>

                        <th scope="col">
                            <p-iconfield size="small">
                                <p-inputicon><i class="pi pi-search"></i></p-inputicon>
                                <input (input)="onFilterInput($event, 'area')"
                                       [ngModel]="currentFilters['area']"
                                       fluid
                                       maxlength="255" pInputText placeholder="Pesquise" size="small" type="text"/>
                                @if (currentFilters['area']) {
                                    <p-inputicon
                                            (click)="clearFilter('area')"
                                            (keydown.enter)="$event.preventDefault(); clearFilter('area')"
                                            (keydown.space)="$event.preventDefault(); clearFilter('area')"
                                            tabindex="0"
                                            class="pi pi-times cursor-pointer"
                                    />
                                }
                            </p-iconfield>
                        </th>

                        <th scope="col">
                            <p-iconfield size="small">
                                <p-inputicon><i class="pi pi-search"></i></p-inputicon>
                                <input (input)="onFilterInput($event, 'cargo')"
                                       [ngModel]="currentFilters['cargo']"
                                       fluid
                                       maxlength="255" pInputText placeholder="Pesquise" size="small" type="text"/>
                                @if (currentFilters['cargo']) {
                                    <p-inputicon
                                            (click)="clearFilter('cargo')"
                                            (keydown.enter)="$event.preventDefault(); clearFilter('cargo')"
                                            (keydown.space)="$event.preventDefault(); clearFilter('cargo')"
                                            tabindex="0"
                                            class="pi pi-times cursor-pointer"
                                    />
                                }
                            </p-iconfield>
                        </th>
                        <th scope="col">
                            <p-iconfield class="w-full" iconPosition="left">
                                <p-inputicon>
                                    <i class="pi pi-search"></i>
                                </p-inputicon>

                                <p-select
                                        (onChange)="onFilterInput($event.value, 'administrador')"
                                        (onClear)="clearFilter('administrador')"
                                        [(ngModel)]="currentFilters['administrador']"
                                        [options]="perfilOptions"
                                        [showClear]="true"
                                        appendTo="body"
                                        fluid
                                        optionLabel="label"
                                        optionValue="value"
                                        placeholder="Selecione"
                                        styleClass="w-full ">
                                </p-select>


                            </p-iconfield>
                        </th>
                        <th scope="col" alignFrozen="right" pFrozenColumn></th>
                    </tr>
                </ng-template>

                <ng-template let-customer pTemplate="body">
                    @if (!loading) {
                        <tr class="p-selectable-row">
                            <td>
                                {{ customer.nome }}
                            </td>
                            <td>
                                {{ customer.area }}
                            </td>
                            <td>
                                {{ customer.cargo }}
                            </td>
                            <td>
                                {{ customer.administrador ? 'Admin' : 'User' }}
                            </td>
                            <td alignFrozen="right" pFrozenColumn>
                                <div class="flex flex-col sm:flex-row items-center gap-x-2">
                                    <p-button (onClick)="openAddEditViewDialog('view', customer)"
                                        (keydown.enter)="$event.preventDefault(); openAddEditViewDialog('view', customer)"
                                        (keydown.space)="$event.preventDefault(); openAddEditViewDialog('view', customer)"
                                              pTooltip="Visualizar Detalhes"
                                              styleClass="btn-icon" tooltipPosition="top">
                                        <app-icon-eye></app-icon-eye>
                                    </p-button>
                                    <p-button (onClick)="openAddEditViewDialog('edit', customer)"
                                        (keydown.enter)="$event.preventDefault(); openAddEditViewDialog('edit', customer)"
                                        (keydown.space)="$event.preventDefault(); openAddEditViewDialog('edit', customer)"
                                              pTooltip="Editar Usuário"
                                              styleClass="btn-icon" tooltipPosition="left">
                                        <app-icon-pencil [size]="'21px'" color="#292D32"></app-icon-pencil>
                                    </p-button>
                                    @if (customer.situacao === 'ATIVO') {
                                        <ng-container #buttonInativar>
                                            <p-button (onClick)="requestDisable(customer)"
                                                (keydown.enter)="$event.preventDefault(); requestDisable(customer)"
                                                (keydown.space)="$event.preventDefault(); requestDisable(customer)"
                                                      pTooltip="Desabilitar usuário"
                                                      styleClass="btn-icon" tooltipPosition="left">
                                                <app-icon-checked-circle [color]="'#12684C'"
                                                                         [size]="'18px'"></app-icon-checked-circle>
                                            </p-button>
                                        </ng-container>
                                    } @else {
                                        <p-button (onClick)="requestEnable(customer)"
                                            (keydown.enter)="$event.preventDefault(); requestEnable(customer)"
                                            (keydown.space)="$event.preventDefault(); requestEnable(customer)" pTooltip="Habilitar usuário"
                                                  styleClass="btn-icon" tooltipPosition="left">
                                            <app-icon-disabled [size]="'18px'"></app-icon-disabled>
                                        </p-button>
                                    }
                                </div>
                            </td>
                        </tr>
                    }
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="7">Usuários não encontrados.</td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="loadingbody">
                    @for (i of [1, 2, 3, 4, 5]; track i) {
                        <tr>
                            <td>
                                <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                            </td>
                            <td>
                                <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                            </td>
                            <td>
                                <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                            </td>
                            <td>
                                <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                            </td>
                            <td>
                                <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                            </td>
                            <td>
                                <p-skeleton height="1.5rem" width="3rem"></p-skeleton>
                            </td>
                        </tr>
                    }
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>
<!-- DIALOG ADD VIEW EDIT -->

<app-dialog
        [(visible)]="showAddEditViewDialog"
        [closable]="true"
        [headerTitle]="headerTitleAddEditViewDialog"
        width="50vw">
    <p-fluid>
        <form [formGroup]="formAddEditView" class="grid md:grid-cols-2 gap-4">
            <div class="flex flex-col">
                <label for="usuario-nome">Nome @if (modalMode !== 'view') {
                    <span class="required">*</span>
                }</label>
                @if (loadingModal) {
                    <p-skeleton height="2.5rem" width="100%"/>
                } @else {
                    <input id="usuario-nome" [ngClass]="{'readonly-input': modalMode === 'view'}" formControlName="nome" maxlength="255"
                           pInputText
                           placeholder="Digite"/>
                    @if (isFormControlInvalid('nome')) {
                        <span class="required text-sm">Campo obrigatório.</span>
                    }
                }
            </div>
            <div class="flex flex-col">
                <label for="usuario-email">E-mail @if (modalMode !== 'view') {
                    <span class="required">*</span>
                }</label>
                @if (loadingModal) {
                    <p-skeleton height="2.5rem" width="100%"/>
                } @else {
                    <input id="usuario-email" [ngClass]="{'readonly-input': modalMode === 'view'}" formControlName="email" maxlength="255"
                           pInputText
                           placeholder="Digite"/>
                    @if (isFormControlInvalid('email')) {
                        @if (this.formAddEditView.get('email')?.errors?.['required']) {
                            <span class="required text-sm">Campo obrigatório.</span>
                        } @else {
                            <span class="required text-sm">E-mail inválido.</span>
                        }
                    }
                }
            </div>
            <div class="flex flex-col">
                <label for="usuario-area">Área @if (modalMode !== 'view') {
                    <span class="required">*</span>
                }</label>
                @if (loadingModal) {
                    <p-skeleton height="2.5rem" width="100%"/>
                } @else {
                    <input id="usuario-area" [ngClass]="{'readonly-input': modalMode === 'view'}" formControlName="area" maxlength="255"
                           pInputText
                           placeholder="Digite"/>
                    @if (isFormControlInvalid('area')) {
                        <span class="required text-sm">Campo obrigatório.</span>
                    }
                }
            </div>
            <div class="flex flex-col">
                <label for="usuario-cargo">Cargo @if (modalMode !== 'view') {
                    <span class="required">*</span>
                }</label>
                @if (loadingModal) {
                    <p-skeleton height="2.5rem" width="100%"/>
                } @else {
                    <input id="usuario-cargo" [ngClass]="{'readonly-input': modalMode === 'view'}" formControlName="cargo" maxlength="255"
                           pInputText
                           placeholder="Digite"/>
                    @if (isFormControlInvalid('cargo')) {
                        <span class="required text-sm">Campo obrigatório.</span>
                    }
                }
            </div>
            <div class="flex flex-col md:col-span-2">
                <label for="usuario-observacao">Observação</label>
                @if (loadingModal) {
                    <p-skeleton height="2.5rem" width="100%"/>
                } @else {
                    <input id="usuario-observacao" [ngClass]="{'readonly-input': modalMode === 'view'}" formControlName="observacao"
                           maxlength="255"
                           pInputText
                           placeholder="Digite"/>
                }
            </div>
        </form>
    </p-fluid>
    <div class="flex justify-end gap-2" footer>
        <p-button (onClick)="modalMode === 'view' ? closeAddEditViewDialog() : onCancelAddEditViewDialog()"
            (keydown.enter)="$event.preventDefault(); modalMode === 'view' ? closeAddEditViewDialog() : onCancelAddEditViewDialog()"
            (keydown.space)="$event.preventDefault(); modalMode === 'view' ? closeAddEditViewDialog() : onCancelAddEditViewDialog()"
                  [label]="modalMode === 'view' ? 'Fechar' : 'Cancelar'"
                  styleClass="btn-outlined">
            <app-icon-bold-close-square/>
        </p-button>
        @if (modalMode !== 'view') {
            <p-button (click)="onSaveAddEdit()"
                (keydown.enter)="$event.preventDefault(); onSaveAddEdit()"
                (keydown.space)="$event.preventDefault(); onSaveAddEdit()" class="w-full"
                      label="Salvar" styleClass="btn-red">
                <app-icon-bold-ram-2/>
            </p-button>
        }
    </div>
</app-dialog>

<app-confirm-dialog
        (cancelled)="showAddConfirmDialog = false"
        (confirmed)="onConfirmAddEdit('add'); showAddConfirmDialog = false"
        [(visible)]="showAddConfirmDialog"
        [closable]="false"
        [confirmLabel]="'Sim, salvar'"
        [headerTitle]="'Salvar Novo Usuário'"
        [message]="'Deseja realmente salvar o novo usuário?'"
        cancelLabel="Não"
        id="confirmDialog">
</app-confirm-dialog>

<app-confirm-dialog
        (cancelled)="showEditConfirmDialog = false"
        (confirmed)="onConfirmAddEdit('edit'); showEditConfirmDialog = false"
        [(visible)]="showEditConfirmDialog"
        [closable]="false"
        [confirmLabel]="'Sim, editar'"
        [headerTitle]="'Editar Usuário'"
        [message]="'Deseja realmente editar esse usuário?'"
        cancelLabel="Agora não"
        id="confirmDialog">
</app-confirm-dialog>

<app-confirm-dialog
        (cancelled)="showCancelAddConfirmDialog = false"
        (confirmed)="closeAddEditViewDialog(); showCancelAddConfirmDialog = false; showAlertToast('Nenhum usuário foi adicionado.');"
        [(visible)]="showCancelAddConfirmDialog"
        [closable]="false"
        [confirmLabel]="'Sim, cancelar'"
        [headerTitle]="'Cancelar Criação de Usuário'"
        [message]="'Deseja realmente cancelar a criação do usuário?'"
        cancelLabel="Não, manter dados"
        id="confirmDialog">
</app-confirm-dialog>

<app-confirm-dialog
        (cancelled)="showCancelEditConfirmDialog = false"
        (confirmed)="closeAddEditViewDialog(); showCancelEditConfirmDialog = false; showAlertToast('Nenhum usuário foi editado.')"
        [(visible)]="showCancelEditConfirmDialog"
        [closable]="false"
        [confirmLabel]="'Sim, cancelar'"
        [headerTitle]="'Cancelar Edição de Usuário'"
        [message]="'Deseja realmente cancelar a edição do usuário?'"
        cancelLabel="Não, manter dados"
        id="confirmDialog">
</app-confirm-dialog>

<app-confirm-dialog
        (cancelled)="showDisableConfirmDialog = false"
        (confirmed)="confirmDisable(selected); showDisableConfirmDialog = false"
        [(visible)]="showDisableConfirmDialog"
        [closable]="false"
        [confirmLabel]="'Sim, desabilitar'"
        [headerTitle]="'Desabilitar Usuário'"
        [message]="'Deseja realmente desabilitar este usuário?'"
        cancelLabel="Agora não"
        id="confirmDialog">
</app-confirm-dialog>

<app-confirm-dialog
        (cancelled)="showEnableConfirmDialog = false"
        (confirmed)="confirmEnable(selected); showEnableConfirmDialog = false"
        [(visible)]="showEnableConfirmDialog"
        [closable]="false"
        [confirmLabel]="'Sim, habilitar'"
        [headerTitle]="'Habilitar Usuário'"
        [message]="'Deseja realmente Habilitar este usuário?'"
        cancelLabel="Agora não"
        id="confirmDialog">
</app-confirm-dialog>
